export default {
  'header': {
    'title': 'Funds Record'
  },
  'title': 'Trading Account Number',
  'deposit': {
    'orderId': 'Order Number',
    'createdDate': 'Application Time',
    'tradeAccountNumber': 'Login ID',
    'amount': 'Amount Deposited',
    'realAmount': 'Amount Received',
    'exchangeAmount': 'Amount Credited after Exchange',
    'status': 'Status',
    'remark': 'Remarks',
    'noDeposit': 'No deposit records',
    'fundBankType': 'Deposit Method'
  },
  'withdrawal': {
    'orderId': 'Order Number',
    'createdDate': 'Application Time',
    'tradeAccountNumber': 'Login ID',
    'amount': 'Amount Withdrawn',
    'status': 'Status',
    'remark': 'Remarks',
    'noWithdrawal': 'No withdrawal records',
    'fundBankType': 'Withdrawal Method'
  },
  'transfer': {
    'orderId': 'Order Number',
    'createdDate': 'Application Time',
    'toTradeAccountNumber': 'Transfer In Account',
    'fromTradeAccountNumber': 'Transfer Out Account',
    'amount': 'Amount Applied For',
    'status': 'Status',
    'realAmount': 'Actual Amount Transferred',
    'remark': 'Remarks',
    'noFund': 'No internal transfer records'
  },
  'status': {
    'completed': 'Completed',
    'processing': 'Processing',
    'failure': 'Failed',
    'submitted': 'Submitted',
    'checking': 'Confirmed',
    'canceled': 'Cancelled',
    'verified': 'Submitted',
    'withdrawalcompleted': 'Processed',
    'withdrawn': 'Rejected'
  },
  'errorTips': {
    'unprocessedData': 'There are also unprocessed submissions'
  },
  'export': 'Export',
  'chooseTime': 'Please select time',
  'exchange': {
   'orderId': 'Order Number',
   'createdDate': 'Application time',
   'tradeAccountNumber': 'Login ID',
   'amount': 'Amount Applied For',
   'lockWay': 'Freeze Direction',
   'realAmount': 'Actual Exchange Amount',
   'realExchangeRate': 'Actual Exchange Rate',
   'status': 'Status',
   'remark': 'Remarks',
   'noFund': 'No foreign exchange records'
  }
}
